'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'cherries';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e0ec';
var svgPathData = 'M288 40l12.5-20.5L269.1 .3l-4.9 36.5s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0l0 .1-.1 .8c-.1 .7-.3 1.9-.6 3.5c-.6 3.1-1.5 7.9-2.9 13.9c-2.8 12.2-7.5 29.7-15.2 50.7c-13.9 38.3-37.3 87.6-76 136.4C152.3 233.5 126.6 224 96 224c0 0-96 0-96 112C0 480 144 512 192 512s192-16 192-176c0-112-96-112-96-112c-20.2 0-38.2 4.1-53.1 9.5c26.5-40.4 44.1-79.4 55.7-111.2c5.7-15.6 9.9-29.6 13.1-41.3c11.9 9.5 26.3 22.2 41 37.6c29.1 30.7 58.2 71.2 72.2 119.6c-12-5.3-27-10.3-44.1-12.7C397.3 247.7 416 282.9 416 336c0 71.9-26.1 120.9-62.1 152.9C390.4 506.3 427.7 512 448 512c48 0 192-16 192-176c0-112-96-112-96-112c-32.3 0-59.3 10.6-76.3 19.6c-14.3-67.2-52.9-120.9-88.3-158.2C359.3 64.4 339.8 48 325.3 36.9c-7.3-5.6-13.3-9.8-17.6-12.7c-2.2-1.5-3.9-2.6-5.1-3.4c-.6-.4-1.1-.7-1.4-.9l-.4-.3-.1-.1c0 0 0 0 0 0c0 0 0 0 0 0L288 40z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCherries = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;